class DropdownOverlayManager {
  constructor(dropdownSelector, overlaySelector) {
    this.dropdowns = document.querySelectorAll(dropdownSelector);
    this.overlay = document.querySelector(overlaySelector);

    if (this.dropdowns.length && this.overlay) {
      this.observeDropdowns();
    }
  }

  observeDropdowns() {
    this.dropdowns.forEach((dropdown) => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'class') {
            this.toggleOverlay();
          }
        });
      });

      observer.observe(dropdown, { attributes: true });
    });
  }

  toggleOverlay() {
    const anyVisible = Array.from(this.dropdowns).some(dropdown =>
      dropdown.classList.contains('is-visible')
    );

    if (anyVisible) {
      this.overlay.classList.add('visible');
    } else {
      this.overlay.classList.remove('visible');
    }
  }
}

(function () {
  new DropdownOverlayManager('.header__dropdown', '.overlay-blur');
})();
